import {Record, List, Map} from 'immutable';
import moment, {type Moment} from 'moment-timezone';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import RoleMode, {Role} from '../common/role';
import NameModel, {Name} from '../common/name';
import ImageModel, {Image} from '../common/image';
import Address from '../common/address';

export enum KeyStatus {
    Primary = 'PRIMARY',
    Secondary = 'SECONDARY',
}

class KeyChild extends Record<{
    childId?: string;
    status?: KeyStatus;
}>({
    childId: undefined,
    status: undefined,
}) {}

export class Employee extends Record<{
    id: string;
    employeeId: string;
    famlyId: string;
    loginId: string;
    institutionId: string;
    name: Name;
    status: string;
    email: string;
    groupTitle: string;
    groupId: string;
    role: Role;
    keyChildren: List<KeyChild>;
    image: Image;
    contacts: List<any>;
    updating: boolean;
    startDate: string;
    behaviors: BehaviorsCollection;
    birthday: string;
    checkedIn: boolean;
    checkinTime: null;
    checkoutTime: null;
    estimatedCheckoutTime: null;
    isSick: boolean;
    isAbsent: boolean;
    hasVacation: boolean;
    hasChildSick: boolean;
    phone: string;
    address: typeof Address.default;
    startDateMoment: Moment | null;
    endDate: string | null;
    endDateMoment: Moment | null;
    timezone: string;
    extraInfo: string;
    checkins: List<any>;
    tagIds: List<string>;
    tags: List<any>;
    conversation: Map<any, any>;
    statusRegistrations: List<any>;
    customemployeeid: string | null;
    holidayAllowance: number | null;
    state: string | null;
    deletion: {
        canDelete: boolean;
        canExport: boolean;
    } | null;
}>({
    id: '',
    employeeId: '',
    famlyId: '',
    loginId: '',
    institutionId: '',
    name: new Name(),
    status: '',
    email: '',
    groupTitle: '',
    groupId: '',
    role: new Role(),
    keyChildren: List(),
    image: new Image(),
    contacts: List(),
    updating: false,
    startDate: '',
    behaviors: new BehaviorsCollection([]),
    birthday: '',
    checkedIn: false,
    checkinTime: null,
    checkoutTime: null,
    estimatedCheckoutTime: null,
    isSick: false,
    isAbsent: false,
    hasVacation: false,
    hasChildSick: false,
    phone: '',
    address: Address.default,
    startDateMoment: null,
    endDate: null,
    endDateMoment: null,
    timezone: '',
    extraInfo: '',
    checkins: List(),
    tagIds: List(),
    tags: List(),
    conversation: Map(),
    statusRegistrations: List(),
    customemployeeid: '',
    holidayAllowance: null,
    state: null,
    deletion: null,
}) {}

const fromAPI = data => {
    return new Employee({
        ...data,
        checkins: List(data.checkins),
        id: data.employeeId,
        name: NameModel.fromAPI(data.name),
        address: Address.fromAPI(data.address),
        image: ImageModel.fromAPI(data.image),
        role: data.roles2.length > 0 ? RoleMode.fromAPI(data.roles2[0]) : null,
        keyChildren: List(data.keyChildren.map(c => new KeyChild(c))),
        startDate: data.localStartDate,
        behaviors: new BehaviorsCollection(data.behaviors),
        startDateMoment: data.localStartDate ? moment(data.localStartDate) : null,
        endDateMoment: data.localEndDate ? moment(data.localEndDate) : null,
        statusRegistrations: List(data.statusRegistrations),
    });
};

const fromSimpleEmployeeAPI = data => {
    return new Employee(data);
};

export default {
    record: Employee,
    default: new Employee(),
    fromAPI,
    fromSimpleEmployeeAPI,
};
